import { useEffect, useRef } from 'react';
import { supabase } from './supabase';

const HEARTBEAT_INTERVAL = 30000;

export function useHeartbeat() {
  const timerRef = useRef(null);

  useEffect(() => {
    const beat = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) return;
        await fetch('/api/user/heartbeat', {
          method: 'POST',
          headers: { Authorization: `Bearer ${session.access_token}` },
        });
      } catch { /* non-fatal */ }
    };

    beat();
    timerRef.current = setInterval(beat, HEARTBEAT_INTERVAL);
    return () => clearInterval(timerRef.current);
  }, []);
}
